import { useState } from "react";
import styles from "./Insights.module.css";
import { IInsightsProps } from "../../interfaces/IReport";

import { ReactComponent as ArrowIcon } from "../../../../assets/icons/arrowIcon.svg";
import selfIcon from "../../../../assets/icons/colaborator.svg";
import teamLeaderIcon from "../../../../assets/icons/TeamLeader.svg";
import managerIcon from "../../../../assets/icons/Manager.svg";
import clientIcon from "../../../../assets/icons/Client.svg";
import colleagueIcon from "../../../../assets/icons/Desktop.svg";
import friendIcon from "../../../../assets/icons/Friend.svg";

export default function Insights({ evaluators, employeeName }: IInsightsProps) {
  const [isExpanded, setIsExpanded] = useState(true);

  const evaluatorGroups = [
    {
      icon: selfIcon,
      label: "Colaborador",
      evaluators: evaluators.selfEvaluation ? [evaluators.selfEvaluation] : [],
      type: "self",
    },
    {
      icon: teamLeaderIcon,
      label: "Team leader",
      evaluators: evaluators.teamLeaders,
      type: "teamLeader",
    },
    {
      icon: managerIcon,
      label: "Manager",
      evaluators: evaluators.managers,
      type: "manager",
    },
    {
      icon: clientIcon,
      label: "Cliente",
      evaluators: evaluators.clients,
      type: "client",
    },
    {
      icon: colleagueIcon,
      label: "Colega trabalho",
      evaluators: evaluators.colleagues,
      type: "colleague",
    },
    {
      icon: friendIcon,
      label: "Colega social",
      evaluators: evaluators.friends,
      type: "friend",
    },
  ];

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={styles.container}>
      <div
        className={styles.header}
        onClick={handleToggle}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleToggle();
          }
        }}
        aria-label={isExpanded ? "Collapse evaluators" : "Expand evaluators"}
      >
        <span>INSIGHTS DO RELATÓRIO</span>
        <span
          className={`${styles.arrow} ${
            isExpanded ? styles.arrowUp : styles.arrowDown
          }`}
        >
          <ArrowIcon className={styles.arrowIcon} />
        </span>
      </div>
      {isExpanded && (
        <div className={styles.evaluatorsGrid}>
          {evaluatorGroups.map((group) =>
            group.evaluators.map((evaluator) => (
              <div key={evaluator.id} className={styles.evaluatorCard}>
                <img
                  src={group.icon}
                  alt={group.label}
                  className={styles.icon}
                />
                <div className={styles.infoContainer}>
                  <p className={styles.label}>{group.label}</p>
                  <p className={styles.name}>
                    {group.type === "client"
                      ? evaluator.clientName || evaluator.name
                      : evaluator.name}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
